import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AdLogsService = {
  // Get all ad logs with full filtering support
  getAdLogs: async ({
    adId,
    macId,
    ipAddress,
    screenName,
    wasCompleted,
    wasSkipped,
    displayReason,
    fromDate,
    toDate,
    advertiserId,
    campaignId,
    pageNumber = 1,
    pageSize = 50,
    batchCode,
  } = {}) => {
    const filterList = [];

    if (adId && !isNaN(adId)) filterList.push(`AdId=${parseInt(adId)}`);
    if (macId && macId.trim())
      filterList.push(`MacId=${encodeURIComponent(macId.trim())}`);
    if (ipAddress && ipAddress.trim())
      filterList.push(`IpAddress=${encodeURIComponent(ipAddress.trim())}`);
    if (screenName && screenName.trim())
      filterList.push(`ScreenName=${encodeURIComponent(screenName.trim())}`);
    if (wasCompleted !== undefined && wasCompleted !== "")
      filterList.push(`WasCompleted=${wasCompleted}`);
    if (wasSkipped !== undefined && wasSkipped !== "")
      filterList.push(`WasSkipped=${wasSkipped}`);
    if (displayReason && !isNaN(displayReason))
      filterList.push(`DisplayReason=${parseInt(displayReason)}`);
    if (fromDate && fromDate.trim())
      filterList.push(`FromDate=${encodeURIComponent(fromDate.trim())}`);
    if (toDate && toDate.trim())
      filterList.push(`ToDate=${encodeURIComponent(toDate.trim())}`);
    if (advertiserId && !isNaN(advertiserId))
      filterList.push(`AdvertiserId=${parseInt(advertiserId)}`);
    if (campaignId && !isNaN(campaignId))
      filterList.push(`CampaignId=${parseInt(campaignId)}`);
    if (batchCode && batchCode.trim())
      filterList.push(`BatchCode=${encodeURIComponent(batchCode.trim())}`);
    if (pageNumber) filterList.push(`pageNumber=${pageNumber}`);
    if (pageSize) filterList.push(`pageSize=${pageSize}`);

    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/itouch/ad-logs${filterString}`);
    return response.data;
  },

  // Get all ad logs with pagination and filtering (legacy method)
  adLogsList: async ({
    adId,
    macId,
    deviceName,
    page = 1,
    pageSize = 10,
  } = {}) => {
    const filterList = [];
    if (adId && !isNaN(adId)) filterList.push(`AdId=${parseInt(adId)}`);
    if (macId && macId.trim())
      filterList.push(`MacId=${encodeURIComponent(macId.trim())}`);
    if (deviceName && deviceName.trim())
      filterList.push(`DeviceName=${encodeURIComponent(deviceName.trim())}`);
    if (page) filterList.push(`Page=${page}`);
    if (pageSize) filterList.push(`PageSize=${pageSize}`);

    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/itouch/ad-logs${filterString}`);
    return response.data;
  },

  // Create a new ad log entry
  create: async (data) => {
    try {
      const response = await apiService.post("/itouch/ad-logs", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating ad log:", error);
      throw error;
    }
  },

  // Get ad log by id
  getAdLogById: async (id) => {
    try {
      const response = await apiService.get(`/itouch/ad-logs/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad log:", error);
      throw error;
    }
  },

  // Get logs for specific ad
  getLogsByAdId: async (adId, page = 1, pageSize = 10) => {
    try {
      const filterList = [];
      filterList.push(`AdId=${parseInt(adId)}`);
      filterList.push(`Page=${page}`);
      filterList.push(`PageSize=${pageSize}`);

      const filterString = `?${filterList.join("&")}`;
      const response = await apiService.get(`/itouch/ad-logs${filterString}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad logs by ad id:", error);
      throw error;
    }
  },

  // Get logs for specific device
  getLogsByDeviceId: async (macId, page = 1, pageSize = 10) => {
    try {
      const filterList = [];
      filterList.push(`MacId=${encodeURIComponent(macId)}`);
      filterList.push(`Page=${page}`);
      filterList.push(`PageSize=${pageSize}`);

      const filterString = `?${filterList.join("&")}`;
      const response = await apiService.get(`/itouch/ad-logs${filterString}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad logs by device:", error);
      throw error;
    }
  },

  // Get ad logs batch list with filtering
  getAdLogsBatchList: async ({
    macId,
    batchCode,
    fromDate,
    toDate,
    pageNumber = 1,
    pageSize = 50,
  } = {}) => {
    try {
      const filterList = [];

      if (macId && macId.trim())
        filterList.push(`MacId=${encodeURIComponent(macId.trim())}`);

      if (batchCode && batchCode.trim())
        filterList.push(`BatchCode=${encodeURIComponent(batchCode.trim())}`);

      if (fromDate && fromDate.trim())
        filterList.push(`FromDate=${encodeURIComponent(fromDate.trim())}`);

      if (toDate && toDate.trim())
        filterList.push(`ToDate=${encodeURIComponent(toDate.trim())}`);

      if (pageNumber) filterList.push(`PageNumber=${pageNumber}`);

      if (pageSize) filterList.push(`PageSize=${pageSize}`);

      const filterString =
        filterList.length > 0 ? `?${filterList.join("&")}` : "";

      const response = await apiService.get(
        `/itouch/ad-logs/batchlist${filterString}`,
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching ad logs batch list:", error);
      throw error;
    }
  },
};

export default AdLogsService;
